import { render, staticRenderFns } from "./orderViewCredentialsComponent.vue?vue&type=template&id=f2dc27da&scoped=true&"
import script from "./orderViewCredentialsComponent.vue?vue&type=script&lang=js&"
export * from "./orderViewCredentialsComponent.vue?vue&type=script&lang=js&"
import style0 from "./orderViewCredentialsComponent.vue?vue&type=style&index=0&id=f2dc27da&prod&lang=less&scoped=true&"
import style1 from "./orderViewCredentialsComponent.vue?vue&type=style&index=1&id=f2dc27da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dc27da",
  null
  
)

export default component.exports